import { GROUP_NAME, Option } from '@greenkub-fronts/shared/interface';
import { getCurrentProject } from '../../customer-area.slice';
import { OPTION_DEFAULT_CODE_BY_GEKA } from '@greenkub-fronts/shared/static-data';
import { chosenOptionListBuilder } from '@greenkub-fronts/shared/utils';
import { cloneDeep } from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const editProcessOptions = createAsyncThunk(
  'editProcessOptions',
  async (
    data: { optionName: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const processedOptions: any = cloneDeep(
      getState().customerArea.processedOptions
    );

    const currentProject = getCurrentProject(getState());

    if (!currentProject) return;

    if (processedOptions[data.optionName]) {
      processedOptions[data.optionName] = undefined;
    } else {
      const gekaStudioName = currentProject.configurations[0].chosenStudioList
        .studio.name as string;

      const catalogue = await dispatch(
        extra.apiSlice.endpoints.getCatalogue.initiate({
          groupName: GROUP_NAME.CATALOGUE_FOR_CUSTOMER_AREA,
        })
      );

      if (data.optionName === 'terrasse') {
        const findedOption = catalogue.data.options.find(
          (option: Option) =>
            option.defaultCode ===
            OPTION_DEFAULT_CODE_BY_GEKA.find(
              (studio) => studio.name === gekaStudioName
            )?.terrasse
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'pergola') {
        const findedOption = catalogue.data.options.find(
          (option: Option) =>
            option.defaultCode ===
            OPTION_DEFAULT_CODE_BY_GEKA.find(
              (studio) => studio.name === gekaStudioName
            )?.pergola
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'toitureVege') {
        const findedOption = catalogue.data.options.find(
          (option: Option) =>
            option.defaultCode ===
            OPTION_DEFAULT_CODE_BY_GEKA.find(
              (studio) => studio.name === gekaStudioName
            )?.toitureVege
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'bardage') {
        const findedOption = catalogue.data.options.find(
          (option: Option) =>
            option.defaultCode ===
            OPTION_DEFAULT_CODE_BY_GEKA.find(
              (studio) => studio.name === gekaStudioName
            )?.bardage
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'menuiserieAnthra') {
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '0600-01244'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'accompagnement') {
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '1300-00025'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'aideDechargement') {
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '1300-00026'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'forfaitCoaching') {
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '1300-00024'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          1
        );
      } else if (data.optionName === 'taillePergola') {
        let result: string | null = '15';
        if (['taillePergola', 'tailleTerrasse'].includes(data.optionName)) {
          result = window.prompt('Quelle surface de pergola ?', '15');
        }
        if (!result) return;
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '0110-00308'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          parseInt(result)
        );
      } else if (data.optionName === 'tailleTerrasse') {
        let result: string | null = '15';
        if (['taillePergola', 'tailleTerrasse'].includes(data.optionName)) {
          result = window.prompt('Quelle surface de terrasse ?', '15');
        }
        if (!result) return;
        const findedOption = catalogue.data.options.find(
          (option: Option) => option.defaultCode === '0110-00307'
        );
        processedOptions[data.optionName] = chosenOptionListBuilder(
          findedOption,
          parseInt(result)
        );
      }
    }

    processedOptions.haveBeenTouch = true;

    return { processedOptions: processedOptions };
  }
);
